export function config(vue) {
  vue.prototype.wxConfig = function () {
    if (!is_weixn()) {
      return
    }
    let url = location.href.split("#")[0]
    if (this.isios) {
      url = localStorage.getItem("wxShreUrl")
    }
    this.$axios.get("/wechat/sign?url=" + encodeURIComponent(url)).then(res => {
      shareShow();
      // res.data.debug = false
      res.data.openTagList = ["wx-open-launch-app", "wx-open-launch-weapp"];
      res.data.jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData']
      if (res.data.appId) {
        localStorage.setItem('wxAppId', res.data.appId)
      }
      wx.config(res.data);
    })


    wx.checkJsApi({
      jsApiList: ['chooseImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res) {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      }
    });
  }
}
export function share(vue) {
  vue.prototype.share = function (obj) {
    wx.ready(function (link) {
      //          分享到朋友圈
      wx.updateTimelineShareData({
        title: obj.title, // 分享标题
        link: obj.link,
        imgUrl: obj.imgUrl,
        success: function () {
          // alert('分享成功');
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          console.log(2);
        }
      });

      //          分享给朋友
      wx.updateAppMessageShareData({
        title: obj.title,
        desc: obj.desc,
        link: obj.link,
        imgUrl: obj.imgUrl,
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          //  alert('分享成功');
        },
        cancel: function () {

        }
      });

      //          分享给朋友
      wx.onMenuShareQQ({
        title: obj.title,
        desc: obj.desc,
        link: obj.link,
        imgUrl: obj.imgUrl,
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {

        },
        cancel: function () {

        }
      });

      wx.onMenuShareWeibo({
        title: obj.title,
        desc: obj.desc,
        link: obj.link,
        imgUrl: obj.imgUrl,
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {

        },
        cancel: function () {

        }
      });

      wx.onMenuShareQZone({
        title: obj.title,
        desc: obj.desc,
        link: obj.link,
        imgUrl: obj.imgUrl,
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {

        },
        cancel: function () { }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/public/share.js